const innitialState = {}

export default (state = innitialState, action) => {
  switch (action.type) {
    case 'GET_ORDER_CONFIRMATION':
      return innitialState
    case 'GET_ORDER_CONFIRMATION_SUCCESS':
      return { ...action.payload.data }
    case 'GET_ORDER_CONFIRMATION_FAIL':
      let errorMessage = ''
      return {
        ...innitialState,
        notFound: action.error.request.status === 404,
        errorMessage:
          action.data &&
          action.data.errors &&
          action.data.errors.length > 0 &&
          (action.data.errors.map(
            (item, index) => (errorMessage += item.message)
          ) ||
            errorMessage)
      }
    default:
      return state || innitialState
  }
}



// WEBPACK FOOTER //
// ./src/features/Confirmation/reducer.js